import * as React from "react";
import Header from "./Header";
import { MultipleChoiceForm } from "./MultipleChoiceForm";
import { connect } from "react-redux";
import { Choice } from "../../models/choice";
import { FormStep, Step } from "../../store/application/applicationState";
import {
  ApplicationAction,
    setLoanReason,    setOtherLoanReason,
  gotoStep
} from "../../store/application/applicationActions";
import ApplicationContent from "../applicationContent";
import ApplicationFooter from "../applicationFooter";
import {
    Button,
    FormGroup,
    Label,
    Input,
    CustomInput,
    Row,
    Col
} from "reactstrap";
import { trackEvent } from "../../util/gtm";
import { OtherReasonAttribute } from "../../models/otherreasonattribute";
import { RootState } from "../../store";


type Props = ReturnType<typeof mapDispatchToProps > & ReturnType<typeof mapStateToProps>;
interface StepFourState {
    dirty: boolean;
    otherReason?: string;
    show: boolean;
}
class LoanReason extends React.Component<Props, StepFourState> {
    constructor(props: Props) {
        super(props);

        this.state = {
            dirty: false,
            otherReason: props.application.data.otherReasonOfLoan,
            show: false
        };

        this.next = this.next.bind(this);
    }
    next(): void {
        this.setState({ dirty: true });
        const otherReasonValid = !OtherReasonAttribute.hasError(this.state.otherReason);


        if (otherReasonValid == true) {
            //all good.
            this.props.setOtherLoanReason(
                this.state.otherReason,
              
            );
            trackEvent(
                "Hvad skal pengene bruges til",
                this.state.otherReason,
                "Hvad skal pengene bruges til",
                this.state.otherReason
            )
        }
    }
  
  private choices: Array<Choice<number>> = [
      new Choice<number>("Møbler", 0, () => this.props.setLoanReason("Møbler")),
      new Choice<number>("Elektronik", 1, () => this.props.setLoanReason("Elektronik")),
      new Choice<number>("Boligforbedringer", 2, val => this.props.setLoanReason("Boligforbedringer")),
      new Choice<number>("Rejser", 3, () => this.props.setLoanReason("Rejser")),
      new Choice<number>("Bil/Køretøjer", 4, () => this.props.setLoanReason("Bil/Køretøjer")),
      new Choice<number>("Båd", 5, () => this.props.setLoanReason("Båd")),
      new Choice<number>("Indfrielse af gæld", 6, () => this.props.setLoanReason("Indfrielse af gæld")),
      new Choice<number>("Andet", 7, () => this.setState({ show: true }))
  ];

    render() {
        var params = window.location.search.toString();
        var mark;
        var regex = /((&|\?)step=)[0-9]{1,2}/gi;
        if (params != "") {
            if (params.includes("step")) {
                params = params.replace(regex, "$1" + this.props.application.currentStep);

            }
            else {
                mark = "&step=" + this.props.application.currentStep;

            }
        }
        else {
            mark = "?step=" + this.props.application.currentStep;
        };

        if (mark == undefined)
            mark = "";
        var stepQuery = window.location.protocol + "//" + window.location.host + window.location.pathname + params + mark;
        window.history.pushState({ path: stepQuery }, '', stepQuery)
    return (
      <div>
            <Header formStep={FormStep.Other} step={Step.LoanReason} />
            <ApplicationContent>
                {this.state.show == false && <MultipleChoiceForm
                    title="Hvad skal pengene bruges til?"
                    paragraph=""
                    choices={this.choices}
                    collumns={3}
                />}
         
             {this.state.show && <FormGroup id="OtherloanInput">
                    <h3 className="mb-0 mb-sm-5 text-center">HVAD SKAL PENGENE BRUGES TIL?</h3>
                    <div className="text-center col"><p>Skriv formål</p></div>
                 <Input
                     className={
                         this.state.dirty && OtherReasonAttribute.hasError(this.state.otherReason)
                             ? "is-invalid"
                             : ""
                     }
                     type="text"
                     id="otherLoan"
                        name="otherLoan"
                     placeholder="Indtast formål"
                     value={this.state.otherReason}
                     onChange={event => this.setState({ otherReason: event.target.value })}
                 />
                    {this.state.dirty &&
                      
                     OtherReasonAttribute.hasError(this.state.otherReason) && (
                         <div className="invalid-feedback">
                             {OtherReasonAttribute.getErrorMessage()}
                         </div>
                     )}
             </FormGroup>} 

            </ApplicationContent>
            <ApplicationFooter>
                <Row className="mt-2">
                    <Col className="col-12 text-right">
                        <Button className="back" onClick={() => this.props.previous()}>
                            Tilbage
              </Button>
                        {this.state.show && <Button className="next" onClick={() => {
                            this.next();
                            trackEvent(
                                "Hvad skal pengene bruges til",
                                this.props.application.data.otherReasonOfLoan,
                                "Hvad skal pengene bruges til",
                                this.props.application.data.otherReasonOfLoan
                            )
                        }}>
                            Næste
                        </Button>}
                    </Col>
                </Row>

            </ApplicationFooter>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch: (action: ApplicationAction) => void) => ({
    previous: () => dispatch(gotoStep(Step.RKI)),
    setLoanReason: (reason: string) => {
        dispatch(setLoanReason(reason));
        trackEvent(
            "Hvad skal pengene bruges til",
            reason,
            "Hvad skal pengene bruges til",
            reason
        )

    },
    next: () => dispatch(gotoStep(Step.Marital)),
      setOtherLoanReason: ( otherReason: string) => {
          dispatch(setOtherLoanReason( otherReason));
    
    }
  
});
const mapStateToProps = (state: RootState) => ({
    application: state.applicationState
});
export default connect(mapStateToProps, mapDispatchToProps)(LoanReason);
